/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import {FormattedMessage} from 'react-intl'
import {Heading} from '@salesforce/retail-react-app/app/components/shared/ui'

const CartTitle = () => {
    return (
        <Heading as="h1" fontSize="xl" textTransform="uppercase" mb="6">
            <FormattedMessage defaultMessage="Shopping Bag" id="cart_title.title.shopping_bag" />
        </Heading>
    )
}

export default CartTitle
